import { render, staticRenderFns } from "./ListeStatsGlobal.vue?vue&type=template&id=b5f17936&"
import script from "./ListeStatsGlobal.vue?vue&type=script&lang=js&"
export * from "./ListeStatsGlobal.vue?vue&type=script&lang=js&"
import style0 from "./ListeStatsGlobal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports